export default __webpack_public_path__ + "static/media/pic22.700377cd.jpg";